import { TFunction } from 'i18next';

const KEY_BY_STATUS: Record<string, string> = {
  Identified: 'useCaseOverview.statusIdentified',
  Qualified: 'useCaseOverview.statusQualified',
  Prioritized: 'useCaseOverview.statusPrioritized',
  'In Progress': 'useCaseOverview.statusInProgress',
  Completed: 'useCaseOverview.statusCompleted',
  Abandoned: 'useCaseOverview.statusAbandoned',
};

export function getUseCaseStatusLabel(status: string, t: TFunction): string {
  const key = KEY_BY_STATUS[status];
  return key ? (t(key) as string) : status;
}

export const USE_CASE_STATUS_VALUES = [
  'Identified',
  'Qualified',
  'Prioritized',
  'In Progress',
  'Completed',
  'Abandoned',
] as const;
